import { useSnackbarMutation } from "../../hooks";
import { BucketAttachment } from "../models";
import { MUTATIONS } from "../mutations";

type UseUsers = {
  onUsersLatestPrivacyReportCreated?: (attachment: BucketAttachment) => void;
};

export function useUsers(opts?: UseUsers) {
  // -- create survey apartment report
  const [
    invokeCreateUsersLatestPrivacyReport,
    {
      loading: createUsersLatestPrivacyReportLoading,
      error: createUsersLatestPrivacyReportError,
    },
  ] = useSnackbarMutation(MUTATIONS.CREATE_USERS_LATEST_PRIVACY_REPORT, {
    onCompleted: (data) => {
      if (opts?.onUsersLatestPrivacyReportCreated) {
        opts.onUsersLatestPrivacyReportCreated(
          data.createUsersLatestPrivacyPreferencesReport as BucketAttachment
        );
      }
    },
  });

  return {
    createUsersLatestPrivacyReport: invokeCreateUsersLatestPrivacyReport,
    createUsersLatestPrivacyReportLoading,
    createUsersLatestPrivacyReportError,
  };
}
